// @ts-ignore
/* eslint-disable */
import { request } from '../../request'

/** No comments are provided by the backend GET /projects */
export async function projectsControllerList(
  // Param type generated by superposition
  params: API.ProjectsControllerListParams,
  options?: { [key: string]: any },
) {
  return request<any>('/projects', {
    method: 'GET',
    params: {
      // page has a default value: 1
      page: '1',
      // pageSize has a default value: 20
      pageSize: '20',
      ...params,
    },
    ...(options || {}),
  })
}

/** No comments are provided by the backend POST /projects */
export async function projectsControllerCreate(
  body: API.CreateProjectDto,
  options?: { [key: string]: any },
) {
  return request<any>('/projects', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  })
}

/** No comments are provided by the backend GET /projects/${param0} */
export async function projectsControllerGet(
  // Param type generated by superposition
  params: API.ProjectsControllerGetParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params
  return request<any>(`/projects/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  })
}

/** No comments are provided by the backend PUT /projects/${param0} */
export async function projectsControllerUpdate(
  // Param type generated by superposition
  params: API.ProjectsControllerUpdateParams,
  body: API.UpdateProjectDto,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params
  return request<any>(`/projects/${param0}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  })
}

/** No comments are provided by the backend DELETE /projects/${param0} */
export async function projectsControllerDelete(
  // Param type generated by superposition
  params: API.ProjectsControllerDeleteParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params
  return request<any>(`/projects/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  })
}
